import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiCourseSubjectActivityTypes extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }
}